import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { ListMessagesComponent } from './list-messages/list-messages.component';
import { SharedModule } from 'app/shared/shared.module';
import { MeetingsRoutingModule } from './messages-routing.module';
import { DialogsModule } from 'app/dialogs/dialogs.module';
import { ViewMessageComponent } from './view-message/view-message.component';
import { FollowUpsListingComponent } from './follow-ups-listing/follow-ups-listing.component';
import { CycleListingComponent } from './cycle-listing/cycle-listing.component';
import { SpamListingComponent } from './spam-listing/spam-listing.component';
import { NoActionComponent } from './no-action/no-action.component';
import { RemovedListingComponent } from './removed-listing/removed-listing.component';
import { InactiveListingComponent } from './inactive-listing/inactive-listing.component';
import { VipListingComponent } from './vip-listing/vip-listing.component';
import { VsmListingComponent } from './vsm-listing/vsm-listing.component';
import { AvailableListingComponent } from './available-listing/available-listing.component';
import { AvailableActionsComponent } from './available-listing/available-actions/available-actions.component';
import { ViewMeetingComponent } from './view-meeting/view-meeting.component';
import { EditMeetingComponent } from './edit-meeting/edit-meeting.component';
import { RestoreMeetingComponent } from './restore-meeting/restore-meeting.component';
import { ReleaseReplayActionComponent } from './view-message/release-replay-action/release-replay-action.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import {
  ListMessagesMobileRowComponent,
} from './list-messages/list-messages-mobile-row/list-messages-mobile-row.component';
import {
  AssociatedProductsMobileRowComponent,
} from './view-meeting/associated-products-mobile-row/associated-products-mobile-row.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
  declarations: [
    ListMessagesComponent,
    ViewMessageComponent,
    ViewMeetingComponent,
    RestoreMeetingComponent,
    EditMeetingComponent,
    FollowUpsListingComponent,
    CycleListingComponent,
    SpamListingComponent,
    NoActionComponent,
    RemovedListingComponent,
    InactiveListingComponent,
    VipListingComponent,
    VsmListingComponent,
    AvailableListingComponent,
    AvailableActionsComponent,
    ReleaseReplayActionComponent,
    ListMessagesMobileRowComponent,
    AssociatedProductsMobileRowComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MeetingsRoutingModule,
    DialogsModule,
    ReactiveFormsModule,
    EditorModule,
    NgxIntlTelInputModule,
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: '/tinymce/tinymce.min.js' },
  ],
})
export class MessagesModule {
}
